import { defineMessages } from 'react-intl'

export default defineMessages({
  contacts: {
    id: 'containers.CustomerTeamPage.TeamCard.contacts',
    defaultMessage: 'producers',
  },
})